import { render, staticRenderFns } from "./GlobalVisionProfitabilityDialogComponent.vue?vue&type=template&id=9917f22c&scoped=true&lang=pug"
import script from "./GlobalVisionProfitabilityDialogComponent.vue?vue&type=script&lang=ts"
export * from "./GlobalVisionProfitabilityDialogComponent.vue?vue&type=script&lang=ts"
import style0 from "./GlobalVisionProfitabilityDialogComponent.vue?vue&type=style&index=0&id=9917f22c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9917f22c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9917f22c')) {
      api.createRecord('9917f22c', component.options)
    } else {
      api.reload('9917f22c', component.options)
    }
    module.hot.accept("./GlobalVisionProfitabilityDialogComponent.vue?vue&type=template&id=9917f22c&scoped=true&lang=pug", function () {
      api.rerender('9917f22c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dialog/customDialogs/globalVisionProfitability/GlobalVisionProfitabilityDialogComponent.vue"
export default component.exports